import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function WwwNode2(props) {
    return <NodeWithMultipleHandles {...props} nodeType="www2" />;
}
